class CopyCouponButton extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
    this.button = null;
    this.originalLabel = null;
  }

  connectedCallback() {
    // Find the first button inside the custom element
    this.button = this.querySelector("button");
    if (!this.button) return;

    // Store original label for reset
    if (!this.button.hasAttribute("data-original-label")) {
      this.button.setAttribute("data-original-label", this.button.textContent);
    }
    this.originalLabel = this.button.getAttribute("data-original-label");
    this.button.addEventListener("click", this.handleClick);
  }

  disconnectedCallback() {
    if (this.button) {
      this.button.removeEventListener("click", this.handleClick);
    }
  }

  handleClick(event) {
    event.preventDefault();
    const code = this.getAttribute("data-coupon");
    if (code && this.button) {
      navigator.clipboard.writeText(code).then(() => {
        this.button.textContent = "Copied!";
        setTimeout(() => {
          this.button.textContent =
            this.originalLabel || this.button.textContent;
        }, 1500);
      });
    }
  }
}

window.customElements.define("copy-coupon", CopyCouponButton);
